// src/config/index.js
import devConfig from "./config.gilead-dev.json";
import qaConfig from "./config.gilead-qa.json";
import uatConfig from "./config.gilead-uat.json";
import prodConfig from "./config.gilead-prod.json";
import trainingConfig from "./config.gilead-training.json";

// To-do: Get the environment from the system level
const env =  "gilead-prod"; // process.env.REACT_APP_ENV || "dev";

let config;

switch (env) {
  case "gilead-qa":
    config = qaConfig;
    break;
  case "gilead-uat":
    config = uatConfig;
    break;
  case "gilead-prod":
    config = prodConfig;
    break;
  case "gilead-training":
    config = trainingConfig;
    break;
  default:
    config = devConfig;
}

export default config;
